import { type TextMarkStruct } from '../types';

// 下方效果对应的文字大小是 fontSize: 80
const defaultFontSize = 80;

/** 划重点默认(描边)粗细 */
export const textMarkDefaultSize = 50;

export const getLocalTextMarks = () => {
    const data = [
        {
            materialId: 'material_21',
            isVip: false,
            data: {
                type: 'combined',
                defaultFontSize,
                position: 'center',
                defaultColor: '#3272ce',
                enableSize: false,
                enableOpacity: false,
                sizeRange: [],
                src: '../assets/text-mark/选中/web/resource.svg',
                offset: {
                    x: 0,
                    y: 0,
                },
                padding: {
                    x: 5,
                    y: 5,
                },
            },
            thumbnail: {
                height: 501,
                url: 'https://material-center-pre.meitudata.com/material/image/67a579ad9e8c02607.jpg',
                width: 501,
            },
        },
        {
            materialId: 'material_22',
            isVip: false,
            data: {
                type: 'repeat',
                defaultColor: '#fff066',
                defaultFontSize,
                position: 'center',
                enableSize: false,
                enableOpacity: true,
                sizeRange: [],
                src: '../assets/text-mark/背景尖号/web/resource.svg', // 内联 style 后两边被裁剪
                repeatPath:
                    'c6.28,0,9.37-17.38,14.6-22.65,6.31-6.37,14.55,1.41,20.1,9.25,5.56,7.84,9.88,13.29,15.7,13.4',
                offset: {
                    x: 0,
                    y: 2,
                },
                padding: {
                    x: 0,
                    y: 0,
                },
            },
            thumbnail: {
                height: 501,
                url: 'https://material-center-pre.meitudata.com/material/image/67a57983f0f895240.jpg',
                width: 501,
            },
        },
        {
            materialId: 'material_23',
            isVip: false,
            data: {
                type: 'cover',
                defaultColor: '#ffa6ee',
                defaultFontSize,
                position: 'center',
                enableSize: true,
                enableOpacity: true,
                sizeRange: [1, 2, 2.5],
                src: '../assets/text-mark/平滑多圆圈/web/resource.svg',
                offset: {
                    x: 0,
                    y: 0,
                },
                padding: {
                    x: 22,
                    y: -8,
                },
            },
            thumbnail: {
                height: 501,
                url: 'https://material-center-pre.meitudata.com/material/image/67a57968069ea3527.jpg',
                width: 501,
            },
        },
        {
            materialId: 'material_24',
            isVip: false,
            data: {
                type: 'stretch',
                defaultFontSize,
                position: 'center',
                defaultColor: '#ffe501',
                enableSize: false,
                enableOpacity: true,
                sizeRange: [],
                forceStretch: true,
                src: '../assets/text-mark/背景纹理/web/resource.svg',
                offset: {
                    x: 0,
                    y: 0,
                },
                padding: {
                    x: 12,
                    y: 2,
                },
            },
            thumbnail: {
                height: 501,
                url: 'https://material-center-pre.meitudata.com/material/image/67a5795523d779283.jpg',
                width: 501,
            },
        },
        {
            materialId: 'material_25',
            isVip: false,
            data: {
                type: 'combined',
                defaultFontSize,
                position: 'center',
                defaultColor: '#48ef8f',
                enableSize: false,
                enableOpacity: false,
                sizeRange: [],
                src: '../assets/text-mark/不规则边缘/web/resource.svg',
                offset: {
                    x: 0,
                    y: 5,
                },
                padding: {
                    x: -8,
                    y: 0,
                },
            },
            thumbnail: {
                height: 501,
                url: 'https://material-center-pre.meitudata.com/material/image/67a57a120fb1c6922.jpg',
                width: 501,
            },
        },
        {
            materialId: 'material_26',
            isVip: false,
            data: {
                type: 'repeat',
                defaultColor: '#ff50ef',
                defaultFontSize,
                position: 'bottom',
                enableSize: true,
                enableOpacity: true,
                sizeRange: [4, 10, 12],
                src: '../assets/text-mark/绳结下划线/web/resource.svg', // 内联 style 后两边被裁剪
                repeatPath:
                    'c36.72,1.82,48.96-6.63,52.71-9.72,6.61-5.44-1.7-12.08-11.52-7.55-1.52.7-3.07,1.7-4.4,2.85-4.83,4.19-3.56,8.7,2.59,10.17,3.34.79,16.63,4.1,38.08,4.71',
                offset: {
                    x: 0,
                    y: -1,
                },
                padding: {
                    x: 0,
                    y: 0,
                },
            },
            thumbnail: {
                height: 501,
                url: 'https://material-center-pre.meitudata.com/material/image/67a5792c3ae117700.jpg',
                width: 501,
            },
        },
        {
            materialId: 'material_27',
            isVip: false,
            data: {
                type: 'cover',
                defaultColor: '#00f675',
                defaultFontSize,
                position: 'center',
                enableSize: true,
                enableOpacity: true,
                sizeRange: [4, 13, 20],
                src: '../assets/text-mark/不规则圆圈/web/resource.svg',
                offset: {
                    x: 0,
                    y: 0,
                },
                padding: {
                    x: 18,
                    y: 6,
                },
            },
            thumbnail: {
                height: 501,
                url: 'https://material-center-pre.meitudata.com/material/image/67a5790e9fef56778.jpg',
                width: 501,
            },
        },
        {
            materialId: 'material_28',
            isVip: false,
            data: {
                type: 'stretch',
                defaultFontSize,
                position: 'bottom',
                defaultColor: '#ff9a3b',
                enableSize: false,
                enableOpacity: true,
                sizeRange: [],
                forceStretch: true,
                src: '../assets/text-mark/背景下纹理/web/resource.svg',
                offset: {
                    x: 0,
                    y: -12,
                },
                padding: {
                    x: 10,
                    y: 0,
                },
            },
            thumbnail: {
                height: 501,
                url: 'https://material-center-pre.meitudata.com/material/image/67a578f76b0f13967.jpg',
                width: 501,
            },
        },
        {
            materialId: 'material_29',
            isVip: false,
            data: {
                type: 'stretch',
                defaultFontSize,
                position: 'bottom',
                defaultColor: '#00f283',
                enableSize: false,
                enableOpacity: true,
                sizeRange: [],
                forceStretch: true,
                src: '../assets/text-mark/背景下多边形/web/resource.svg',
                offset: {
                    x: 0,
                    y: -13,
                },
                padding: {
                    x: 4,
                    y: 0,
                },
            },
            thumbnail: {
                height: 501,
                url: 'https://material-center-pre.meitudata.com/material/image/67a578e13b43c4125.jpg',
                width: 501,
            },
        },
        {
            materialId: 'material_210',
            isVip: false,
            data: {
                type: 'stretch',
                defaultFontSize,
                position: 'center',
                defaultColor: '#80d4ff',
                enableSize: false,
                enableOpacity: true,
                sizeRange: [],
                forceStretch: false,
                src: '../assets/text-mark/背景圆角矩形/web/resource.svg',
                offset: {
                    x: 0,
                    y: 0,
                },
                padding: {
                    x: 15,
                    y: 0,
                },
            },
            thumbnail: {
                height: 501,
                url: 'https://material-center-pre.meitudata.com/material/image/67a578c750b6b8193.jpg',
                width: 501,
            },
        },
        {
            materialId: 'material_211',
            isVip: false,
            data: {
                type: 'stretch',
                defaultFontSize,
                position: 'bottom',
                defaultColor: '#ffa0f1',
                enableSize: true,
                enableOpacity: true,
                sizeRange: [3, 12, 18],
                forceStretch: false,
                src: '../assets/text-mark/不规则下划线/web/resource.svg',
                offset: {
                    x: 0,
                    y: 5,
                },
                padding: {
                    x: 6,
                    y: 0,
                },
            },
            thumbnail: {
                height: 501,
                url: 'https://material-center-pre.meitudata.com/material/image/67a57897ad8aa5008.jpg',
                width: 501,
            },
        },
        {
            materialId: 'material_212',
            isVip: false,
            data: {
                type: 'combined',
                defaultFontSize,
                position: 'center',
                defaultColor: '#ffffff',
                enableSize: false,
                enableOpacity: false,
                sizeRange: [],
                src: '../assets/text-mark/背景文字框/web/resource.svg',
                offset: {
                    x: 0,
                    y: 0,
                },
                padding: {
                    x: 5,
                    y: 0,
                },
            },
            thumbnail: {
                height: 501,
                url: 'https://material-center-pre.meitudata.com/material/image/67a579c350fce1125.jpg',
                width: 501,
            },
        },
        {
            materialId: 'material_213',
            isVip: false,
            data: {
                type: 'stretch',
                defaultFontSize,
                position: 'bottom',
                defaultColor: '#ffa0f1',
                enableSize: false,
                enableOpacity: true,
                sizeRange: [],
                forceStretch: true,
                src: '../assets/text-mark/纹理弯曲线条/web/resource.svg',
                offset: {
                    x: 0,
                    y: -3,
                },
                padding: {
                    x: 7,
                    y: 0,
                },
            },
            thumbnail: {
                height: 501,
                url: 'https://material-center-pre.meitudata.com/material/image/67a5788733c846792.jpg',
                width: 501,
            },
        },
        {
            materialId: 'material_214',
            isVip: false,
            data: {
                type: 'stretch',
                defaultFontSize,
                position: 'bottom',
                defaultColor: '#b688ff',
                enableSize: false,
                enableOpacity: true,
                sizeRange: [],
                forceStretch: true,
                src: '../assets/text-mark/纹理波浪/web/resource.svg',
                offset: {
                    x: 0,
                    y: -4,
                },
                padding: {
                    x: 5,
                    y: 0,
                },
            },
            thumbnail: {
                height: 1042,
                url: 'https://material-center-pre.meitudata.com/material/image/67bd36b7c91406024.png',
                width: 1043,
            },
        },
        {
            materialId: 'material_1',
            isVip: false,
            data: {
                type: 'stretch',
                defaultFontSize,
                position: 'bottom',
                defaultColor: '#b688ff',
                enableSize: true,
                enableOpacity: true,
                sizeRange: [4, 18, 30],
                forceStretch: false,
                src: '../assets/text-mark/横线/web/resource.svg',
                offset: {
                    x: 0,
                    y: -12,
                },
                padding: {
                    x: 1,
                    y: 0,
                },
            },
            thumbnail: {
                height: 500,
                url: 'https://material-center-pre.meitudata.com/material/image/67c130a72e25d6038.png',
                width: 500,
            },
        },
        {
            materialId: 'material_2',
            isVip: false,
            data: {
                type: 'repeat',
                defaultColor: '#b688ff',
                defaultFontSize,
                position: 'bottom',
                enableSize: true,
                enableOpacity: true,
                sizeRange: [3, 10, 16],
                src: '../assets/text-mark/波浪线/web/resource.svg', // 内联 style 后两边被裁剪
                repeatPath: 'c8.65,0,8.65,9.67,17.29,9.67s8.65-9.67,17.29-9.67',
                offset: {
                    x: 0,
                    y: -2,
                },
                padding: {
                    x: 0,
                    y: 0,
                },
            },
            thumbnail: {
                height: 500,
                url: 'https://material-center-pre.meitudata.com/material/image/67c130de7b02d7666.png',
                width: 500,
            },
        },
        {
            materialId: 'material_3',
            isVip: false,
            data: {
                type: 'cover',
                defaultColor: '#ffe131',
                defaultFontSize,
                position: 'center',
                enableSize: true,
                enableOpacity: true,
                sizeRange: [4, 12, 20],
                src: '../assets/text-mark/平滑圆圈/web/resource.svg',
                offset: {
                    x: 0,
                    y: 0,
                },
                padding: {
                    x: 0,
                    y: 0,
                },
            },
            thumbnail: {
                height: 500,
                url: 'https://material-center-pre.meitudata.com/material/image/67c14bcbb9eca4194.png',
                width: 500,
            },
        },
        {
            materialId: 'material_4',
            isVip: false,
            data: {
                type: 'cover',
                defaultColor: '#ffaff0',
                defaultFontSize,
                position: 'center',
                enableSize: false,
                enableOpacity: true,
                sizeRange: [],
                src: '../assets/text-mark/纹理圆圈/web/resource.svg',
                offset: {
                    x: 0,
                    y: 0,
                },
                padding: {
                    x: 0,
                    y: -4,
                },
            },
            thumbnail: {
                height: 250,
                url: 'https://material-center-pre.meitudata.com/material/image/6744243188b8890.png',
                width: 502,
            },
        },
        {
            materialId: 'material_5',
            isVip: false,
            data: {
                type: 'use',
                defaultFontSize,
                position: 'bottom',
                defaultColor: '#e883fe',
                enableSize: false,
                enableOpacity: true,
                sizeRange: [16, 34, 50],
                src: '../assets/text-mark/三角形/web/resource.svg',
                offset: {
                    x: 0,
                    y: 14,
                },
                padding: {
                    x: 0,
                    y: 0,
                },
            },
            thumbnail: {
                height: 226,
                url: 'https://material-center-pre.meitudata.com/material/image/6744244c4bb489321.png',
                width: 450,
            },
        },
        {
            materialId: 'material_6',
            isVip: false,
            data: {
                type: 'stretch',
                defaultFontSize,
                position: 'bottom',
                defaultColor: '#ffa050',
                enableSize: false,
                enableOpacity: true,
                sizeRange: [],
                forceStretch: true,
                src: '../assets/text-mark/纹理双横线/web/resource.svg',
                offset: {
                    x: 0,
                    y: -2,
                },
                padding: {
                    x: 0,
                    y: 0,
                },
            },
            thumbnail: {
                height: 254,
                url: 'https://material-center-pre.meitudata.com/material/image/6744247049acf4902.png',
                width: 460,
            },
        },
        {
            materialId: 'material_7',
            isVip: false,
            data: {
                type: 'stretch',
                defaultFontSize,
                position: 'bottom',
                defaultColor: '#48ef8f',
                enableSize: true,
                enableOpacity: true,
                sizeRange: [6, 10, 20],
                forceStretch: false,
                src: '../assets/text-mark/弯曲线条/web/resource.svg',
                offset: {
                    x: 0,
                    y: 6,
                },
                padding: {
                    x: 0,
                    y: 0,
                },
            },
            thumbnail: {
                height: 166,
                url: 'https://material-center-pre.meitudata.com/material/image/6744249c3dac84475.png',
                width: 342,
            },
        },
        {
            materialId: 'material_8',
            isVip: false,
            data: {
                type: 'repeat',
                defaultFontSize,
                position: 'bottom',
                defaultColor: '#eb5c39',
                enableSize: true,
                enableOpacity: true,
                sizeRange: [1, 3, 5],
                src: '../assets/text-mark/双折角横线/web/resource.svg',
                repeatPath: 'l21.52,9.58,21.52,-9.58',
                offset: {
                    x: 0,
                    y: -2,
                },
                padding: {
                    x: 0,
                    y: 0,
                },
            },
            thumbnail: {
                height: 254,
                url: 'https://material-center-pre.meitudata.com/material/image/674424d1ec8226929.png',
                width: 494,
            },
        },
        {
            materialId: 'material_9',
            isVip: false,
            data: {
                type: 'use',
                defaultFontSize,
                position: 'center',
                defaultColor: '#48ef8f',
                enableSize: false,
                enableOpacity: true,
                sizeRange: [],
                src: '../assets/text-mark/背景圆/web/resource.svg',
                offset: {
                    x: 0,
                    y: 0,
                },
                padding: {
                    x: 0,
                    y: 0,
                },
            },
            thumbnail: {
                height: 534,
                url: 'https://material-center-pre.meitudata.com/material/image/674424f03512f4771.png',
                width: 1204,
            },
        },
        {
            materialId: 'material_10',
            isVip: false,
            data: {
                type: 'stretch',
                defaultFontSize,
                position: 'bottom',
                defaultColor: '#48ef8f',
                enableSize: true,
                enableOpacity: true,
                sizeRange: [3, 10, 16],
                forceStretch: false,
                src: '../assets/text-mark/虚线/web/resource.svg',
                offset: {
                    x: 0,
                    y: -16,
                },
                padding: {
                    x: 0,
                    y: 0,
                },
            },
            thumbnail: {
                height: 500,
                url: 'https://material-center-pre.meitudata.com/material/image/67c14ca0b57973043.png',
                width: 500,
            },
        },
        {
            materialId: 'material_11',
            isVip: false,
            data: {
                type: 'use',
                defaultFontSize,
                position: 'bottom',
                defaultColor: '#ffa6ee',
                enableSize: false,
                enableOpacity: true,
                sizeRange: [],
                src: '../assets/text-mark/圆点/web/resource.svg',
                offset: {
                    x: 0,
                    y: 10,
                },
                padding: {
                    x: 0,
                    y: 0,
                },
            },
            thumbnail: {
                height: 155,
                url: 'https://material-center-pre.meitudata.com/material/image/674425333cc735048.png',
                width: 332,
            },
        },
        {
            materialId: 'material_12',
            isVip: false,
            data: {
                type: 'stretch',
                defaultColor: '#48ef8f',
                defaultFontSize,
                position: 'center',
                enableSize: true,
                enableOpacity: true,
                sizeRange: [12, 50, 70],
                forceStretch: false,
                src: '../assets/text-mark/背景横线/web/resource.svg',
                offset: {
                    x: 0,
                    y: 4,
                },
                padding: {
                    x: 2,
                    y: 0,
                },
            },
            thumbnail: {
                height: 500,
                url: 'https://material-center-pre.meitudata.com/material/image/67c165e4c067c3021.png',
                width: 500,
            },
        },
        {
            materialId: 'material_13',
            isVip: false,
            data: {
                type: 'stretch',
                defaultFontSize,
                position: 'center',
                defaultColor: '#ffe131',
                enableSize: false,
                enableOpacity: true,
                sizeRange: [],
                forceStretch: false,
                src: '../assets/text-mark/背景矩形/web/resource.svg',
                offset: {
                    x: 0,
                    y: 0,
                },
                padding: {
                    x: 6,
                    y: 0,
                },
            },
            thumbnail: {
                height: 500,
                url: 'https://material-center-pre.meitudata.com/material/image/67c14dae5f4006033.png',
                width: 500,
            },
        },
        {
            materialId: 'material_14',
            isVip: false,
            data: {
                type: 'stretch',
                defaultFontSize,
                position: 'center',
                defaultColor: '#ffa6ee',
                enableSize: true,
                enableOpacity: true,
                sizeRange: [40, 56, 100],
                forceStretch: false,
                src: '../assets/text-mark/背景波浪/web/resource.svg',
                offset: {
                    x: 0,
                    y: 14,
                },
                padding: {
                    x: 10,
                    y: 0,
                },
            },
            thumbnail: {
                height: 248,
                url: 'https://material-center-pre.meitudata.com/material/image/67441f052764e847.png',
                width: 304,
            },
        },
        {
            materialId: 'material_15',
            isVip: false,
            data: {
                type: 'repeat',
                defaultColor: '#ff953b',
                defaultFontSize,
                position: 'bottom',
                enableSize: true,
                enableOpacity: true,
                sizeRange: [3, 10, 20],
                src: '../assets/text-mark/手绘波浪/web/resource.svg',
                repeatPath:
                    'c9.37-5.27,12.11-8.69,21.7-7.61,7.6.86,14.41,6.32,21.7,9.26,9.49,3.82,19.98,3.23,29.19-1.64',
                offset: {
                    x: 0,
                    y: 0,
                },
                padding: {
                    x: -5,
                    y: 0,
                },
            },
            thumbnail: {
                height: 500,
                url: 'https://material-center-pre.meitudata.com/material/image/67c14e248a5133869.png',
                width: 500,
            },
        },
    ];

    const tasks = data.map(async (item) => {
        const src = await import(item.data.src);
        const nextData = {
            ...item.data,
            src: src.default,
        };
        const ret = {
            ...item,
            data: nextData,
            thumbnailBlack: item.thumbnail,
        };
        return ret as TextMarkStruct;
    });

    return Promise.all(tasks);
};
